import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "card p-6 sm:p-8 mb-4" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "title-main" }, "ข้อมูลสินค้า", -1)
const _hoisted_5 = {
  key: 0,
  class: "mt-4 flex flex-col gap-4"
}
const _hoisted_6 = { class: "flex-1 flex space-x-4" }
const _hoisted_7 = ["src", "onerror"]
const _hoisted_8 = {
  class: "flex-1 flex flex-col w-1/3",
  style: {"word-break":"break-word"}
}
const _hoisted_9 = { class: "clamp-2 text-base" }
const _hoisted_10 = { class: "text-gray-400 text-sm" }
const _hoisted_11 = { class: "flex-1 flex space-x-4" }
const _hoisted_12 = { class: "flex flex-col flex-1 gap-4" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 text-base" }, "ราคาต่อหน่วย", -1)
const _hoisted_14 = { class: "flex h-full items-end text-base" }
const _hoisted_15 = { class: "flex flex-col flex-1 items-start" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 text-base" }, "จำนวน", -1)
const _hoisted_17 = { class: "flex h-full items-end text-base" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("hr", { class: "block lg:hidden" }, null, -1)
const _hoisted_19 = { class: "flex-1 flex space-x-0 lg:space-x-4" }
const _hoisted_20 = {
  key: 0,
  class: "flex flex-1 flex-col"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 text-base" }, "ส่วนลด", -1)
const _hoisted_22 = { class: "flex h-full items-end text-base" }
const _hoisted_23 = { class: "flex flex-1 lg:flex-col justify-end items-end flex-1 gap-4" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 text-base" }, "ราคารวม", -1)
const _hoisted_25 = { class: "flex h-auto lg:h-full items-center text-base sm:text-2xl lg:text-base text-green-island-600 lg:text-black" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 text-base pl-2" }, "บาท", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "bg-gray-100 rounded-md h-0.5 mx-6" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        class: "bullet_main",
        src: require('@/assets/icon_bullet/product_info.svg'),
        alt: ""
      }, null, 8, _hoisted_3),
      _hoisted_4
    ]),
    (_ctx.data)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedArray(_ctx.data.products), (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.productId,
              class: "card lg:shadow-none lg:rounded-none flex flex-col lg:flex-row space-x-0 lg:space-x-4 p-6 gap-4"
            }, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("img", {
                  class: "w-16 h-16 sm:w-28 lg:w-16 sm:h-28 lg:h-16 rounded-md object-contain",
                  src: _ctx.imgUrl(item.productCoverUrl),
                  onerror: `this.src='${_ctx.envMedia}/public/icons/web/g_product.webp'`,
                  alt: ""
                }, null, 8, _hoisted_7),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("p", _hoisted_9, _toDisplayString(item.productTitle), 1),
                  _createElementVNode("p", _hoisted_10, _toDisplayString(item.productSku), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.func_service.currency(item.productUnitPrice)), 1)
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createElementVNode("p", _hoisted_17, _toDisplayString(item.productQty), 1)
                ])
              ]),
              _hoisted_18,
              _createElementVNode("div", _hoisted_19, [
                (item.discountUnitPrice)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _hoisted_21,
                      _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.func_service.currency(item.discountUnitPrice || 0)) + " " + _toDisplayString(item?.isDiscountOnPercent ? '%':'บาท'), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_23, [
                  _hoisted_24,
                  _createElementVNode("div", _hoisted_25, [
                    _createTextVNode(_toDisplayString(_ctx.func_service.currency(item.itemsPriceRow || 0)) + " ", 1),
                    _hoisted_26
                  ])
                ])
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _hoisted_27
  ]))
}